const GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST =
    'GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST';
const GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS =
    'GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS';
const GET_LINK_ID_FOR_PRE_FILLED_FILE_FAILED =
    'GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS';
const SHOW_BULK_PAYMENT_LOADER = 'SHOW_BULK_PAYMENT_LOADER';
const HIDE_BULK_PAYMENT_LOADER = 'HIDE_BULK_PAYMENT_LOADER';

const GET_RECENT_BULK_PAYMENT_LINK_REQUEST =
    'GET_RECENT_BULK_PAYMENT_LINK_REQUEST';
const GET_RECENT_BULK_PAYMENT_LINK_SUCCESS =
    'GET_RECENT_BULK_PAYMENT_LINK_SUCCESS';
const GET_RECENT_BULK_PAYMENT_LINK_FAILED =
    'GET_RECENT_BULK_PAYMENT_LINK_FAILED';

const UPLOAD_BULK_PAYMENT_LINK_REQUEST = 'UPLOAD_BULK_PAYMENT_LINK_REQUEST';
const UPLOAD_BULK_PAYMENT_LINK_SUCCESS = 'UPLOAD_BULK_PAYMENT_LINK_SUCCESS';
const UPLOAD_BULK_PAYMENT_LINK_FAILED = 'UPLOAD_BULK_PAYMENT_LINK_FAILED';

const DOWNLOAD_BULK_PAYMENT_LINK_REQUEST = 'DOWNLOAD_BULK_PAYMENT_LINK_REQUEST';
const DOWNLOAD_BULK_PAYMENT_LINK_SUCCESS = 'DOWNLOAD_BULK_PAYMENT_LINK_SUCCESS';
const DOWNLOAD_BULK_PAYMENT_LINK_FAILED = 'DOWNLOAD_BULK_PAYMENT_LINK_FAILED';

export {
    GET_LINK_ID_FOR_PRE_FILLED_FILE_REQUEST,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_SUCCESS,
    GET_LINK_ID_FOR_PRE_FILLED_FILE_FAILED,
    GET_RECENT_BULK_PAYMENT_LINK_REQUEST,
    GET_RECENT_BULK_PAYMENT_LINK_SUCCESS,
    GET_RECENT_BULK_PAYMENT_LINK_FAILED,
    UPLOAD_BULK_PAYMENT_LINK_REQUEST,
    UPLOAD_BULK_PAYMENT_LINK_SUCCESS,
    UPLOAD_BULK_PAYMENT_LINK_FAILED,
    DOWNLOAD_BULK_PAYMENT_LINK_REQUEST,
    DOWNLOAD_BULK_PAYMENT_LINK_SUCCESS,
    DOWNLOAD_BULK_PAYMENT_LINK_FAILED,
    SHOW_BULK_PAYMENT_LOADER,
    HIDE_BULK_PAYMENT_LOADER,
};
